<template>
    <!-- <section class="main-content is-transparent"> -->
    <!-- <div class="hero">{{ tesserato?.id }}</div> -->
    <!-- </section> -->
    <div>
        <div class="gradient-overlay"></div>

        <section class="main-content">
            <!-- <div class="hero"> -->

            <GridBox>
                <GridItem size="100%" :colidx="3" class="p-5" glassy>
                    <GridBody class="m-0">
                        <h1
                            class="subtitle is-2 is-subtle is-uppercase has-text-primary mb-0 pb-0 has-text-weight-bold"
                        >
                            {{ $t("login.header") }}
                        </h1>
                        <div
                            class="description is-2 is-subtle has-text-weight-normal"
                        >
                            <p>{{ $t("login.description") }}</p>
                        </div>
                    </GridBody>
                </GridItem>
                <GridItem size="100%" :colidx="2" class="p-5" glassy>
                    <GridBody class="m-0 fullwidth">
                        <ValidationObserver v-slot="{ handleSubmit, invalid }">
                            <form
                                class="form"
                                @submit.prevent="handleSubmit(authLogin)"
                            >
                                <div
                                    class="spinner-container"
                                    v-if="isLoadingData"
                                >
                                    <b-loading
                                        class="spinner-loader"
                                        :is-full-page="false"
                                        v-model="isLoadingData"
                                    />
                                </div>
                                <ValidationProvider
                                    rules="required|min:5|max:50"
                                    v-slot="{ errors }"
                                    class="form__element"
                                >
                                    <b-field
                                        :message="errors[0]"
                                        class="is-custom-field"
                                        :label="$t('login.form.email.label')"
                                    >
                                        <b-input
                                            :disabled="isLoadingData"
                                            type="email"
                                            class="is-custom-input"
                                            :placeholder="
                                                $t(
                                                    'login.form.email.placeholder'
                                                )
                                            "
                                            v-model="userinput.email"
                                        />
                                    </b-field>
                                </ValidationProvider>
                                <ValidationProvider
                                    rules="required|min:8|max:24"
                                    v-slot="{ errors }"
                                    class="form__element"
                                >
                                    <b-field
                                        :message="errors[0]"
                                        class="is-custom-field"
                                        :label="$t('login.form.password.label')"
                                    >
                                        <b-input
                                            :disabled="isLoadingData"
                                            type="password"
                                            autocomplete="current-password"
                                            class="is-custom-input"
                                            :placeholder="
                                                $t(
                                                    'login.form.password.placeholder'
                                                )
                                            "
                                            v-model="userinput.password"
                                        />
                                    </b-field>
                                </ValidationProvider>
                                <div
                                    v-if="isErrored"
                                    class="has-text-danger mb-5"
                                >
                                    {{ $t("login.form.accountnotfound") }}
                                </div>
                                <div class="field is-grouped">
                                    <div class="control">
                                        <b-button
                                            class="is-uppercase is-size-4 primary-btn"
                                            :disabled="invalid || isLoadingData"
                                            native-type="submit"
                                        >
                                            {{ $t("login.form.submit") }}
                                        </b-button>
                                        <!-- <button
                                    class="button is-link"
                                    @click="authLogout()"
                                >
                                    Logout
                                </button> -->
                                    </div>
                                    <!-- <div class="control">
                                <button class="button is-link is-light">
                                    Cancel
                                </button>
                            </div> -->
                                </div>
                            </form>
                        </ValidationObserver>
                    </GridBody>
                </GridItem>
                <GridItem size="100%" :colidx="1" class="p-5" glassy>
                    <!-- 98, 167, 212 -->
                    <!-- 110, 102, 224 -->
                    <GridBody class="m-0">
                        <span
                            class="is-size-5 has-text-weight-bold mx-1 mb-2 is-primary"
                        >
                            {{ $t("login.registerquestion") }}</span
                        >
                        <button
                            class="is-uppercase is-size-4 primary-btn pt-5"
                            @click="$router.push(localePath('/u/register'))"
                        >
                            {{ $t("login.register") }}
                        </button>

                        <button
                            class="primary-btn is-size-6 mt-4 is-uppercase is-warning"
                            @click="
                                $router.push(localePath('/u/forgot-password'))
                            "
                        >
                            {{ $t("login.forgotpassword") }}
                        </button>
                    </GridBody>
                </GridItem>
            </GridBox>

            <!-- </div> -->
        </section>
    </div>
</template>
          

<style lang="scss" scoped>
.fullwidth {
    width: 100% !important;
    align-items: stretch;
}
.form {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    /* align-items: center; */
    min-width: 300px;
}
.is-centered {
    display: flex;
    justify-content: center;
    align-items: center;
}
.gradient-overlay {
    transition: all 0.2s ease-in-out;
    opacity: 0.5;
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    width: 100%;
    overflow: hidden;
    height: 90vh;
    width: 100%;
    background: linear-gradient(
        180deg,
        rgba(var(--color-primary-alt-rgba), 0.25) 0%,
        rgba(var(--color-primary-alt-rgba), 0) 100%
    );
    /* background: red; */
}
.main-content {
    /* padding-bottom: 5rem; */
    max-width: 1280px;
    height: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    /* margin-bottom: 2rem; */
    padding: 0 1rem;
}
.spinner-loader {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    // z-index: 10;
    // pointer-events: none;
}
.spinner-container {
    position: absolute;
    width: 100%;
    height: 100%;
    background: var(--bg-secondary);
    z-index: 1000000000;
    display: flex;
    left: 0;
    top: 0;
    justify-content: center;
    align-items: center;
}
.login-actions {
    /* text-align: center; */

    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 2rem;
    font-size: 1.125rem;

    .action-link {
        color: var(--primary);
        font-weight: 600;
        text-decoration: none;
        margin: 0 0.5rem;
        &:hover {
            text-decoration: underline;
        }
    }
}

.is-custom-input {
    background: var(--bg);
}

@keyframes appear {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>

<script>
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { email, max, min, oneOf, required } from "vee-validate/dist/rules";
import GridBox from "~/components/GridBox";
import GridItem from "~/components/GridItem";
import GridBody from "~/components/GridBody";

extend("required", {
    ...required,
    message: "Campo richiesto",
});

extend("min", {
    ...min,
    message: "Minimo caratteri: {length}",
});

extend("max", {
    ...max,
    message: "Massimo caratteri: {length}",
});

extend("email", {
    ...email,
    message: "Indirizzo e-mail non valido.",
});

extend("oneOf", {
    ...oneOf,
    message: "Paese non valido",
});
export default {
    name: "PublicLogin",
    data() {
        return {
            pageTitle: "TDF*P — " + this.$t("login.meta.title"),
            isLoadingData: false,
            isErrored: false,
            userinput: {
                email: "",
                password: "",
            },
        };
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        GridBox,
        GridItem,
        GridBody,
    },
    beforeMount() {
        // this.fetchData();
    },
    mounted() {
        this.$store.commit("setCurrPageTitle", this.$t("login.header"));
        this.enterAnimation();
    },
    layout: "default",

    watch: {
        $route(to, from) {
            this.$store.commit("setCurrPageTitle", this.$t("login.header"));
        },
    },
    head() {
        return {
            title: this.pageTitle,
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.prevRoute = from;
        });
    },
    methods: {
        async authLogin() {
            this.isLoadingData = true;
            try {
                await this.$store.dispatch("public-auth/login", {
                    email_address: this.userinput.email,
                    password: this.userinput.password,
                });

                if (this.$store.getters["public-auth/authedUser"].refToken) {
                    // console.log("logged in");

                    // get logged in status

                    await this.$store.dispatch("public-auth/refresh");

                    this.$store.dispatch("setLoggedIn", true);
                    this.$router.push(this.localePath("/u"));

                    // refresh page
                } else {
                    this.isErrored = true;
                    // reset form
                    // this.userinput.email = "";
                    // this.userinput.password = "";

                    this.isLoadingData = false;
                }
            } catch (e) {
                console.error(e);
                console.log(e);
            } finally {
            }
        },
        // async asyncData() {

        //     // console.log(this.$router.currentRoute);
        //     return this.loadedEvent;
        // },
        enterAnimation() {
            const anime = this.$anime;
            anime({
                targets: ".main-content",
                easing: "easeInOutQuad",
                opacity: [0, 1],
                filter: ["blur(2rem)", "blur(0px)"],
                duration: 360,
            });
        },
    },
};
</script>

